import {
  Controller,
  useFormContext,
  type FieldPathByValue,
  type FieldValues,
} from 'react-hook-form';

import type { DateRange, DateRangePreset } from '~shared/ui/date-range-picker';
import { DateRangePicker } from '~shared/ui/date-range-picker';

type Props<TFieldValues extends FieldValues> = {
  name: FieldPathByValue<TFieldValues, DateRange>;
  presets?: DateRangePreset[];
  minDate?: Date;
  maxDate?: Date;
  align?: 'start' | 'end';
  onChange?: () => void;
};

export function PeriodRangeFilter<TFieldValues extends FieldValues>({
  name,
  presets,
  minDate,
  maxDate,
  align = 'end',
  onChange,
}: Props<TFieldValues>) {
  const { control } = useFormContext<TFieldValues>();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, ...controllerProps }) => (
        <DateRangePicker
          {...controllerProps}
          field={{
            ...field,
            onChange: (period: DateRange) => {
              field.onChange(period);

              const isComplete = Boolean(period.startDate && period.endDate);
              const isCleared = !period.startDate && !period.endDate;

              if (isComplete || isCleared) {
                onChange?.();
              }
            },
          }}
          align={align}
          minDate={minDate}
          maxDate={maxDate}
          presets={presets}
        />
      )}
    />
  );
}
